import { daysOfWeek } from './common.constants';

export const daysOfWeekCheckboxOptions = daysOfWeek.map((day) => ({ label: day.substring(0, 3), value: day }));
export const daysOfWeekCheckboxOptionsFull = daysOfWeek.map((day) => ({ label: day, value: day }));
